export default defineNuxtPlugin(() => {
  const { isIntegrationEnabled } = useUtils()
  if (!isIntegrationEnabled('constructor')) return
  const { $uiEvents } = useNuxtApp()
  const scriptOnDemand = runScriptOnDemand()

  runOnNuxtReady(() => {
    scriptOnDemand.addSrc('https://cnstrc.com/js/cust/realtruck_amZrnR.js')
    scriptOnDemand.load()
  })

  $uiEvents.$on('orderPlaced', setPurchaseData)

  function setPurchaseData(receiptObj: Receipt) {
    window.cnstrcPurchaseData = {
      order_id: receiptObj.orderId,
      revenue: receiptObj.summary.cartSubtotal,
      items: receiptObj.items.map((item) => ({
        item_id: item.productLineSlug,
        variation_id: `${item.productLineSlug}_${item.productSlug}`,
        price: item.salePrice,
        count: item.qty,
      })),
    }
  }
})
